import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "26",
  height: "25",
  fill: "none",
  viewBox: "0 0 26 25"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#fantasy_svg__a)" }, [
      _createElementVNode("path", {
        fill: "currentColor",
        d: "M21.75 0a4 4 0 0 1 4 4v17a4 4 0 0 1-4 4h-8.648a3.486 3.486 0 0 0 3.482-3.48v-1.063a3.517 3.517 0 0 0 4.216-2.506l2.33-8.697c.241-.9.115-1.86-.35-2.666a3.52 3.52 0 0 0-2.134-1.638L11.95 2.62a3.52 3.52 0 0 0-4.303 2.484l-1.09 4.062H4.233A3.485 3.485 0 0 0 .75 12.649V4a4 4 0 0 1 4-4zM5.886 11.666l-.573 2.136a3.517 3.517 0 0 0 2.485 4.303l6.286 1.684v1.73a.983.983 0 0 1-.982.981H4.233a.984.984 0 0 1-.983-.982v-8.869a.984.984 0 0 1 .983-.983zm4.647-6.53c.233-.135.51-.171.77-.102l8.695 2.33a1.017 1.017 0 0 1 .718 1.244l-2.33 8.694a1.016 1.016 0 0 1-1.244.718l-1.472-.395-.024-.006-7.2-1.929a1.017 1.017 0 0 1-.717-1.244l2.33-8.693c.07-.26.241-.483.474-.617"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "fantasy_svg__a" }, [
        _createElementVNode("path", {
          fill: "#fff",
          d: "M.75 0h25v25h-25z"
        })
      ])
    ], -1)
  ])))
}
export default { render: render }